import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FadeUp } from "@/components/site/Reveal";

const FAQS = [
    ["How does the 7-day free trial work?", "Click “Start 7-Day Free Trial”, create your free account (or log in), and activate the trial — no card, no payment, no store purchase. You get full premium access for 7 days, and the same account unlocks the SHREDxpro mobile app."],
    ["Can I really cancel anytime?", "Yes. There are no lock-in contracts. Cancel from the app or by contacting support and you keep access until the end of your current period."],
    ["Is my plan actually personalized?", "Yes. Your plan is generated from your body metrics, goal, experience, equipment, diet preference and schedule — then the adaptation engine keeps tuning it based on what you log."],
    ["What is the AI Coach?", "An always-on coach inside the app that understands your plan, your history and your progress. Ask it about exercises, meals, swaps, plateaus — anything."],
    ["Do I need the mobile app?", "The full SHREDxpro experience — daily workouts, logging, tracking and coach chat — lives in the iOS and Android app. This website is where you start: create your account, start a trial or purchase a membership, then continue in the app."],
    ["Which platforms are supported?", "SHREDxpro is available on iOS via the App Store and on Android via Google Play."],
    ["How do I delete my account?", "You can delete your account and all associated data at any time — see the Account Deletion page for the steps, or do it directly from your account when logged in."],
    ["Who do I contact for support?", "Email support@shredxpro.com and the team will get back to you. You'll also find quick answers on the Support page."],
];

const Faq = () => {
    const [open, setOpen] = useState(0);
    return (
        <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl px-5 py-14 sm:px-8 sm:py-20">
            <FadeUp>
                <p className="eyebrow">FAQ</p>
                <h2 className="font-display mt-4 text-4xl leading-[1.08] text-white sm:text-5xl">
                    Questions, answered.
                </h2>
            </FadeUp>
            <div className="mt-12 border-t border-white/[0.08]">
                {FAQS.map(([q, a], i) => (
                    <FadeUp key={q} delay={i * 0.04}>
                        <div className="border-b border-white/[0.08]">
                            <button
                                data-testid={`faq-question-${i}`}
                                onClick={() => setOpen(open === i ? -1 : i)}
                                className="flex w-full items-center justify-between gap-6 py-6 text-left"
                            >
                                <span className={`text-base font-semibold transition-colors sm:text-lg ${open === i ? "text-white" : "text-[#c8d3e2]"}`}>
                                    {q}
                                </span>
                                <Plus
                                    className={`h-5 w-5 shrink-0 transition-transform duration-300 ${open === i ? "rotate-45 text-[#3fcbf3]" : "text-[#5c6b82]"}`}
                                />
                            </button>
                            <AnimatePresence initial={false}>
                                {open === i && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                        className="overflow-hidden"
                                    >
                                        <p className="pb-6 pr-10 text-sm leading-relaxed text-[#9fb0c7]" data-testid={`faq-answer-${i}`}>
                                            {a}
                                        </p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </section>
    );
};

export default Faq;
